import Vue from 'vue';
import themeProduct from    './themeproduct.vue';
import themeproduct1 from   './themeproduct1.vue';
Vue.component('themeProduct', themeProduct);
Vue.component('themeProduct1', themeproduct1);